import React from 'react'
import Layout from '../components/Layout/Layout'

const Policy = () => {
  return (
    <Layout>
        <h1>Privacy Policy page</h1>
    </Layout>
  )
}

export default Policy